import React from "react";

const Comp8 = () => {
    return (
        <div>
            <div className="loader-1-container">
                <div style={{ "animationDelay": "100ms" }}></div>
                <div style={{ "animationDelay": "200ms" }}></div>
                <div style={{ "animationDelay": "400ms" }}></div>
            </div>
        </div>
    )
}

export { Comp8 } 